import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
  Grid
} from "@mui/material";
import React from "react";
import "./ProductCard.css";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const ProductCard = ({ product, addToCart }) => {

  return ( 
    
    <Card className="card">
      <CardMedia
      component="img"
      height="400"
      image={product.image}
      alt={product.name}
      sx = {{objectFit:"contain"}}
      />
      <CardContent>
        <Typography gutterBottom variant="h5">
         <span>{product.name}</span>
        </Typography>
        <Typography color="textsecondary" variant="subtitle1">
          {/* <CurrencyRupeeIcon sx={{fontSize:"small"}}/> */}
          ${product.cost}
        </Typography>
        <Rating name="read-only" value={product.rating} readOnly />
        </CardContent >
        <CardActions>
        <Button
        className="button" 
        variant="contained" 
        color="primary"
        fullWidth
        onClick ={addToCart}>ADD TO CART</Button>
      </CardActions>
    </Card>
    
  );
};

export default ProductCard;
